type NavigateToParams = {
  pathName: string;
  params: Record<string, string>;
  navigationFn?: (url: string) => void;
};

export const navigateTo = ({
  pathName,
  params,
  navigationFn = (url) => (window.location.href = url),
}: NavigateToParams) => {
  const currentUrl = new URL(window.location.href);
  const newUrl = new URL(pathName, window.location.origin);

  currentUrl.searchParams.forEach((value, key) => {
    newUrl.searchParams.set(key, value);
  });

  Object.entries(params).forEach(([key, value]) => {
    newUrl.searchParams.set(key, value);
  });

  navigationFn(newUrl.href);
};
